import axios from 'axios'
// import Vuetify from 'vuetify'

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 * 
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
		tipologie: {
			default: null,
			valueNonApplied: null,
			value: null
		},
	},

	getters: {
		defaultFilters(state) {
			let defaultFilters = {};
			for (let stateKey in state) {
				defaultFilters[stateKey] = state[stateKey].default;
			}
			return defaultFilters;
		},
		appliedFilters(state) {
			let appliedFilters = {};
			for (let stateKey in state) {
				appliedFilters[stateKey] = state[stateKey].value;
			}
			
			return appliedFilters;
		},
		thereAreFiltersApplied(state) {
			let thereAreFiltersApplied = false;
			for (let stateKey in state) {
				if (state[stateKey].value != state[stateKey].default) {
					thereAreFiltersApplied = true;
				}
			}
			return thereAreFiltersApplied;
		},
		tipologie(state) {
			return state.tipologie;
		},
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_TIPOLOGIE_NOT_APPLIED(state, value) {
			state.tipologie.valueNonApplied = value;
		},
		// SET_TIPOLOGIE(state, value) {
		// 	state.tipologie.value = value;
		// }
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		applyFilters({ state }) {
			for (let stateKey in state) {
				state[stateKey].value = state[stateKey].valueNonApplied;
			}
		},
		resetFilters({ state }) {
			for (let stateKey in state) {
				state[stateKey].value = state[stateKey].default;
				state[stateKey].valueNonApplied = state[stateKey].default;
			}
		}
	}
}

// export default {
// 	namespaced: true,
// 	state,
// 	getters,
// 	mutations,
// 	actions
// }